import {
  addCustomerService,
  addDepartment,
  addEmployee,
  addentconsult,
  addEntCooperation,
  addEntCooperationCase,
  addEntDes,
  addEnterproseClass,
  addEntImage,
  addEntServer,
  addEntTeam,
  addPosition,
  addrecruit,
  addTeamMember,
  applyEntTeams,
  delCustomerService,
  delDepartment,
  delEmployees,
  delEntcommunalList,
  delentconsult,
  delEntCooperationCases,
  delEntCooperations,
  delEntDes,
  delEnterproseClass,
  delEntImage,
  delEntServer,
  delEntTeams,
  delPosition,
  delrecruits,
  delTeamMemners,
  downEntCooperationCase,
  editCurrentEntInfo,
  editCustomerService,
  editDepartment,
  editEmployee,
  editEnt,
  editEntcommunal,
  editentconsult,
  editEntContact,
  editEntCooperationCase,
  editEntDes,
  editEnterproseClass,
  editEntImage,
  editEntServer,
  editEntTeam,
  editPosition,
  editrecruit,
  editTeamMember,
  enableCustomerService,
  getCurrentEntInfo,
  getCustomerServiceDetail,
  getCustomerServiceList,
  getDepartmentList,
  getEmployeeDetail,
  getEmployeelist,
  getEntcommunalList,
  getentconsultdetail,
  getentconsultlist,
  getEntContact,
  getEntCooperationCaseList,
  getEntCooperationList,
  getEntDesList,
  getEnterproseClassDetail,
  getEnterproseClassList,
  getEntimageList,
  getEntInfo,
  getentlistbyname,
  getEntServerDetail,
  getEntServerList,
  getEntTeamDetail,
  getEntTeamList,
  getEntTypeList,
  getlicenseClassList,
  getlicenseDetail,
  getLicenseEntList,
  getMineEntlist,
  getPositionList,
  getrecruitlist,
  getTeamMember,
  getTeamMemberDetail,
  initEnterproseClass,
  muliteunderrecruit,
  muliteuprecruit,
  patchEnterproseClass,
  postEntcommunal,
  shelfentconsult,
  sortDepartment,
  underentconsult,
  upEntCooperationCase
} from '../../services/companyapi'
import {
  getLocalCustomClassList,
  getLocalDepartmentlist,
  getLocalPositionlist,
  setLocalCustomClassList,
  setLocalDepartmentlist,
  setLocalPositionlist
} from '../../utils/util'
import {getmenuvalue} from './videoconfig'

export default {
  state: {
    customClassList: getLocalCustomClassList(),
    departmentList: getLocalDepartmentlist(),
    positionList: getLocalPositionlist(),
    entName: '',
    entLogo: '',
    switchEntQrcodeUrl: ''
  },
  getters: {
    getcustomclasslist: state => {
      let beforelist = [{
        'id': -10,
        'name': '企业信息',
        'jump_url': '/websiteinfo'
        // }, {
        //   'id': -12,
        //   'name': '公司服务',
        //   'jump_url': '/websiteservice'
        // }, {
        //   'id': -6,
        //   'name': '联系我们',
        //   'jump_url': '/websitecontact'
        // }, {
        //   'id': -12,
        //   'name': '公司服务',
        //   'jump_url': '/websiteservice'
      }]

      let a = state.customClassList.length ? beforelist.concat(state.customClassList) : beforelist
      return a
    },
    getDepartmentclasslist: state => {
      let array = []
      let alldepartment = [{
        id: 0,
        name: '全部',
        jump_url: '0'
      }]
      array = array.concat(alldepartment)
      if (state.departmentList && state.departmentList.length) {
        array = array.concat(state.departmentList)
      }
      // let departmentManger = [{
      //   id: -1,
      //   name: '部门管理',
      //   jump_url: '-1'
      // }, {
      //   id: -2,
      //   name: '职位管理',
      //   jump_url: '-2'
      // }]
      // array = array.concat(departmentManger)
      return array
    }
  },
  mutations: {
    setCurrentEntName (state, entName) {
      state.entName = entName
    },
    setCurrentEntLogo (state, entLogo) {
      state.entLogo = entLogo
    },
    setSwitchEntQrcodeUrl (state, qrcodeUrl) {
      state.switchEntQrcodeUrl = qrcodeUrl
    },
    changeCustomClassList (state, list) {
      state.customClassList = list
      setLocalCustomClassList(list)
    },
    changeDepartmentList (state, list) {
      state.departmentList = list
      setLocalDepartmentlist(list)
    },
    changePositionList (state, list) {
      state.positionList = list
      setLocalPositionlist(list)
    }
  },
  actions: {
    getCurrentEntInfo ({commit}) {
      return new Promise((resolve, reject) => {
        getCurrentEntInfo().then(res => {
          if (res.code === 0) {
            let data = res.data
            commit('setCurrentEntName', data.name || '')
            commit('setCurrentEntLogo', data.logo || '')
            commit('setSwitchEntQrcodeUrl', data.switchEntQrcodeUrl || '')
          }
          resolve(res)
        })
      })
    },
    editCurrentEntInfo ({dispatch}, params) {
      return new Promise((resolve, reject) => {
        editCurrentEntInfo(params).then(res => {
          if (res.code === 0) {
            dispatch('getCurrentEntInfo')
          }
          resolve(res)
        })
      })

    },
    getLicenseEntList (store, {name, pageNum, pageSize, type}) {
      let params = {
        name: name,
        pageSize: pageSize,
        pageNum: pageNum
      }
      if (type) {
        params.type = type
      }
      return getLicenseEntList(params)
    },
    getlicenseDetail (store, enterpriseId) {
      return getlicenseDetail(enterpriseId)
    },
    getlicenseClassList (store, type) {
      return getlicenseClassList(type)
    },
    getEntInfo (store) {
      return getEntInfo()
    },
    editEnt (store, params) {
      return editEnt(params)
    },
    getEntDesList (store, entId) {
      let params = {
        entId: entId
      }
      return getEntDesList(params)
    },
    addEntDes (store, params) {
      return addEntDes(params)
    },
    editEntDes (store, {describeId, params}) {
      return editEntDes(describeId, params)
    },
    delEntDes (store, params) {
      return delEntDes(params)
    },
    addEntImage (store, params) {
      return addEntImage(params)
    },
    editEntImage (store, {photoId, params}) {
      return editEntImage(photoId, params)
    },
    delEntImage (store, params) {
      return delEntImage(params)
    },
    getEntimageList (store) {
      return getEntimageList()
    },
    getentlistbyname (store, name) {
      let params = {
        pageNum: 1,
        pageSize: 10,
        name: name
      }
      return getentlistbyname(params)
    },

    getentlistbyphone (store, params) {
      return getentlistbyname(params)
    },
    getMineEntlist (store) {
      return getMineEntlist()
    },
    getEntServerList (store) {
      return getEntServerList()
    },
    addEntServer (store, params) {
      return addEntServer(params)
    },
    editEntServer (store, {serveId, params}) {
      return editEntServer(serveId, params)
    },
    getEntServerDetail (store, serveId) {
      return getEntServerDetail(serveId)
    },
    delEntServer (store, params) {
      return delEntServer(params)
    },
    getEntTypeList (store) {
      return getEntTypeList()
    },
    editEntContact (store, params) {
      return editEntContact(params)
    },
    getEntContact (store) {
      return getEntContact()
    },
    getEnterproseClassList ({commit}, checkStatus) {
      if (checkStatus === 1) {
        return new Promise((resolve, reject) => {
          getEnterproseClassList(checkStatus).then(res => {
            if (res.code === 0) {
              let list = res.data
              let length = list.length
              let menuList = []
              for (let i = 0; i < length; i++) {
                let item = list[i]
                let obj = {
                  id: item.relationId,
                  name: item.functionName,
                  jump_url: getmenuvalue(item),
                  icon: item.classIcon || '',
                  referenceStatus: item.referenceStatus || 0,
                  title: item.functionName,
                }
                menuList.push(obj)
              }
              commit('changeCustomClassList', menuList)
              resolve(res)
            } else {
              reject(res)
            }
          })
        })
      } else {
        return getEnterproseClassList(checkStatus)
      }
    },

    addEnterproseClass (store, params) {
      return addEnterproseClass(params)
    },
    editEnterproseClass (store, proClassinfo) {
      let classid = proClassinfo.id
      let params = proClassinfo.params
      return editEnterproseClass(classid, params)
    },
    patchEnterproseClass (store, params) {
      return patchEnterproseClass(params)
    },
    getEnterproseClassDetail (store, {classId}) {
      return getEnterproseClassDetail(classId)
    },
    delEnterproseClass (store, params) {
      return delEnterproseClass(params)
    },
    initEnterproseClass (store) {
      return initEnterproseClass()
    },
    getEntcommunalList (store, params) {
      return getEntcommunalList(params)
    },
    postEntcommunal (store, params) {
      return postEntcommunal(params)
    },
    editEntcommunal (store, params) {
      return editEntcommunal(params)
    },
    delEntcommunalList (store, params) {
      return delEntcommunalList(params)
    },
    getrecruitlist (store, params) {
      return getrecruitlist(params)
    },
    addrecruit (store, params) {
      return addrecruit(params)
    },
    editrecruit (store, {recruitId, params}) {
      return editrecruit(recruitId, params)
    },
    delrecruits (store, params) {
      return delrecruits(params)
    },
    muliteuprecruit (store, params) {
      return muliteuprecruit(params)
    },
    muliteunderrecruit (store, params) {
      return muliteunderrecruit(params)
    },
    addentconsult (store, params) {
      return addentconsult(params)
    },
    getentconsultlist (store, params) {
      return getentconsultlist(params)
    },
    delentconsult (store, params) {
      return delentconsult(params)
    },
    shelfentconsult (store, params) {
      return shelfentconsult(params)
    },
    underentconsult (store, params) {
      return underentconsult(params)
    },
    getentconsultdetail (store, consultId) {
      return getentconsultdetail(consultId)
    },
    editentconsult (store, {consultId, params}) {
      return editentconsult(consultId, params)
    },
    getEntCooperationList (store) {
      return getEntCooperationList()
    },
    addEntCooperation (store, params) {
      return addEntCooperation(params)
    },

    addEntCooperationCase (store, params) {
      return addEntCooperationCase(params)
    },
    getEntCooperationCaseList (store, params) {
      return getEntCooperationCaseList(params)
    },
    delEntCooperationCases (store, params) {
      return delEntCooperationCases(params)
    },
    upEntCooperationCase (store, params) {
      return upEntCooperationCase(params)
    },
    downEntCooperationCase (store, params) {
      return downEntCooperationCase(params)
    },
    editEntCooperationCase (store, {caseId, params}) {
      return editEntCooperationCase(caseId, params)
    },
    delEntCooperations (store, params) {
      return delEntCooperations(params)
    },
    addCustomerService (store, params) {
      return addCustomerService(params)
    },
    editCustomerService (store, {customerServiceId, params}) {
      return editCustomerService(customerServiceId, params)
    },
    getCustomerServiceList (store, params) {
      return getCustomerServiceList(params)
    },
    getCustomerServiceDetail (store, customerServiceId) {
      return getCustomerServiceDetail(customerServiceId)
    },
    delCustomerService (store, params) {
      return delCustomerService(params)
    },
    enableCustomerService (store, params) {
      return enableCustomerService(params)
    },
    addEntTeam (store, params) {
      return addEntTeam(params)
    },
    editEntTeam (store, {teamId, params}) {
      return editEntTeam(teamId, params)
    },
    getEntTeamList (store, params) {
      return getEntTeamList(params)
    },
    getEntTeamDetail (store, teamId) {
      return getEntTeamDetail(teamId)
    },
    delEntTeams (store, params) {
      return delEntTeams(params)
    },
    getDepartmentList ({commit}) {
      return new Promise((resolve, reject) => {
        getDepartmentList().then(res => {
          if (res.code === 0) {
            let departments = res.data.map(child => {
              let departmentinfo = {
                id: child.id,
                name: child.name,
                jump_url: child.id + '',
                desc: child.desc
              }
              return departmentinfo
            })
            commit('changeDepartmentList', departments)
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
    },
    addDepartment (store, params) {
      return addDepartment(params)
    },
    editDepartment (store, {departmentId, params}) {
      return editDepartment(departmentId, params)
    },
    delDepartment (store, params) {
      return delDepartment(params)
    },
    getPositionList ({commit}) {
      return new Promise((resolve, reject) => {
        getPositionList().then(res => {
          if (res.code === 0) {
            let positionlist = res.data
            commit('changePositionList', positionlist)
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
    },
    addPosition (store, params) {
      return addPosition(params)
    },
    editPosition (store, {positionId, params}) {
      return editPosition(positionId, params)
    },
    delPosition (store, params) {
      return delPosition(params)
    },
    getTeamMember (store, params) {
      return getTeamMember(params)
    },
    addTeamMember (store, params) {
      return addTeamMember(params)
    },
    editTeamMember (store, {memberId, params}) {
      return editTeamMember(memberId, params)
    },
    getTeamMemberDetail (store, memberId) {
      return getTeamMemberDetail(memberId)
    },
    delTeamMemners (store, params) {
      return delTeamMemners(params)
    },
    getEmployeelist (store, params) {
      return getEmployeelist(params)
    },
    addEmployee (store, params) {
      return addEmployee(params)
    },
    editEmployee (store, {employeeId, params}) {
      return editEmployee(employeeId, params)
    },
    getEmployeeDetail (store, employeeId) {
      return getEmployeeDetail(employeeId)
    },
    delEmployees (store, params) {
      return delEmployees(params)
    },
    sortDepartment (store, params) {
      return sortDepartment(params)
    },
    applyEntTeams (store, params) {
      return applyEntTeams(params)
    }
  }
}
